export default __webpack_public_path__ + "static/media/re-open-icon.9c0396b6.svg";